<style scoped="avatar">
.vft-avatar {
  border-radius: 100%;
}
</style>

<template>
  <img :class="`vft-avatar ${iclass}`" :src="avatarUrl" alt="" @click="click" @error="onError">
</template>

<script>
export default{
  name: 'VftAvatar',
  data () {
    return {
      loadError: false
    }
  },
  props: {
    src: {
      type: String,
      required: true
    },
    iclass: {
      type: String,
      default: ''
    },
    defaultAvatar: {
      type: String,
      default: '//vm.gtimg.cn/tencentvideo/vstyle/newvip/style/h5/imgs/common/head_default.svg'
    }
  },
  computed: {
    avatarUrl () {
      if (!this.src || this.loadError) return this.defaultAvatar
      if (/^http(s?):/.test(this.src)) {
        return this.src.replace(/^http(s?):/, '')
      } else if (/^\/\//.test(this.src)) {
        return this.src
      } else if (/^data:/.test(this.src)) {
        return this.src
      } else {
        return this.defaultAvatar
      }
    }
  },
  methods: {
    click (event) {
      this.$emit('click', event)
    },
    onError () {
      this.loadError = true
    }
  }
}
</script>
